<template>
  <div>
    <Button icon="far fa-edit" :label="$t('edit')" @click="setActive(widget.id)" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Button from '@/shared/components/Button'

export default {
  name: 'FormSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.widget.form-side-nav' },
  components: { Button },
  props: {
    widget: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    methods() {
      return [
        { text: 'GET', value: 'GET' },
        { text: 'POST', value: 'POST' },
      ]
    },
  },
  methods: {
    ...mapActions('landing', ['setActive', 'updateOptions']),
    propChanged(path, value) {
      this.updateOptions({
        id: this.widget.id,
        path,
        value,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.advanced-collapsible {
  margin: 10px -10px 0;
}
</style>
